export default function HeroContact() {
    return (
      <section className="hero-contact">
        <h2>reach out to me!</h2>
        <div className="video-wrapper">
          <p>Allison Fish</p>
          <p>she/her</p>
          <p>Email: allison.fish.makes.art@gmail.com</p>
        </div>
      </section>
    );
  }